import React, { Component } from 'react';
import { bool, func, string } from 'prop-types';

import _ from 'lodash';

import {connect} from 'react-redux';

import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Select from '@material-ui/core/Select';

import EsmsDialog from '../../components/EsmsDialog';

import validator, {debounceTimeout} from '../../helpers/validator';

import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as ArchitectActions from '../../actions/architectActions';
import * as ContactActions from '../../actions/contactActions';
import * as HomeActions from '../../actions/homeActions';
import * as UiActions from '../../actions/uiActions';

import classes from './SubscriptionModal.module.css';

class SubscriptionModal extends Component {
    state = {
        checkState:     [],
        clientId:       null,
        disableContact: true,
        event:          null,
        formIsValid:    false,
        formControls:   {
            subscribe: {
                value:           'self',
                placeholder:     '',
                valid:           true,
                touched:         false,
                message:         '',
                validationRules: {

                }
            },
            email: {
                value:           false,
                placeholder:     'Email',
                valid:           true,
                touched:         false,
                message:         '',
                validationRules: {

                }
            },
            sms: {
                value:           false,
                placeholder:     'SMS',
                valid:           true,
                touched:         false,
                message:         '',
                validationRules: {

                }
            },
            contact: {
                value:           '',
                placeholder:     'Select Contact',
                valid:           true,
                touched:         false,
                message:         '',
                validationRules: {

                }
            }
        }
    }

    async componentDidUpdate(prevProps) {
        const { fetchContacts, fetchClientContacts, selectedSubscription } = this.props;

        if (prevProps.selectedSubscription !== selectedSubscription) {
            const clientId = this.calculateClientId(selectedSubscription);

            if (clientId) {
                if (process.env.contactsEnabled) {
                    await fetchClientContacts(clientId);
                } else {
                    await fetchContacts(clientId);
                }
            }
        }
    }

    calculateClientId = selectedSubscription => {
        const parents = selectedSubscription.parent.split('/');
        let clientId;

        if (selectedSubscription.type === 'client') {
            clientId = selectedSubscription.id;
        } else if (selectedSubscription.type === 'company') {
            clientId = null;
        } else {
            clientId = parents[1];
        }

        this.setState({
            clientId
        });

        return clientId;
    }

    setInternalModel = () => {
        const updatedControls = {
            ...this.state.formControls
        };

        updatedControls.email.value = false;
        updatedControls.sms.value = false;

        updatedControls.subscribe.value = 'self';

        updatedControls.contact.value = '';

        this.setState({
            checkState:     [],
            disableContact: true,
            formControls:   updatedControls,
            formIsValid:    true
        });
    }

    validatorDebounce = _.debounce(() => {
        const validatedState = validator(this.state, this.state.event);

        this.setState({
            formControls: validatedState.updatedControls,
            formIsValid:  validatedState.formIsValid
        });
    }, debounceTimeout);

    updateControls = (update, event) => {
        const {name} = event.target;
        const updatedControls = {...this.state.formControls};

        updatedControls[name].value = update;

        this.setState({
            event:        {...event},
            formControls: updatedControls
        });

        this.validatorDebounce();
    }

    prepareTitle = title => {
        const { selectedSite } = this.props;

        switch (title) {
            case 'Area':
                return `${selectedSite.label} Areas`;
            case 'Equipment':
                return `${selectedSite.label} Equipment`;
            case 'System':
                return `${selectedSite.label} Systems`;
            default:
                return title;
        }
    }

    prepareSubtitle = subtitle => {
        switch (subtitle) {
            case 'area':
                return 'all areas';
            case 'equipment':
                return 'all equipment';
            case 'system':
                return 'all systems';
            case 'areaItem':
                return 'area';
            case 'equipmentItem':
                return 'equipment';
            case 'systemItem':
                return 'system';
            default:
                return subtitle;
        }
    }

    handleChange = event => {
        const {value} = event.target;

        this.props.toggleLoading(false);

        this.updateControls(value, event);
    }

    handleRadioButton = event => {
        const { value } = event.target;
        const updatedControls = {...this.state.formControls};

        let formIsValid = true;
        let disableContact = true;

        updatedControls.subscribe.value = value;

        this.props.toggleLoading(false);

        if (value === 'clientContact' || value === 'both') {
            formIsValid = false;
            disableContact = false;
        } else {
            updatedControls.contact.value = '';
        }

        this.setState({
            disableContact,
            formIsValid,
            formControls: updatedControls
        });
    }

    handleCheckbox = name => event => {
        const { checked } = event.target;
        const updatedControls = {...this.state.formControls};

        let checkState = [...this.state.checkState];

        updatedControls[name].value = checked;

        this.props.toggleLoading(false);

        if (checkState.indexOf(name) > -1) {
            checkState = checkState.filter(state => state !== name);
        } else {
            checkState = [...checkState, name];
        }

        this.setState({
            checkState,
            formControls: updatedControls
        });
    }

    handleCreate = async () => {
        const {
            clearErrors,
            createSubscription,
            currentUserId,
            selectedSubscription
        } = this.props;

        let isCreated;

        const selfSubscription = {
            subscriberid:   currentUserId,
            subscribertype: 'user'
        };

        const clientContactSubscription = {
            subscriberid:   this.state.formControls.contact.value,
            subscribertype: 'contact'
        };

        let body = {
            email:       this.state.formControls.email.value,
            entityid:    selectedSubscription.id,
            entityName:  selectedSubscription.name,
            sms:         this.state.formControls.sms.value,
            userid:      currentUserId,
            subscribers: []
        };

        switch (this.state.formControls.subscribe.value) {
            case 'self':
                body.subscribers = [selfSubscription];
                break;
            case 'clientContact':
                body.subscribers = [clientContactSubscription];
                break;
            case 'both':
                body.subscribers = [selfSubscription, clientContactSubscription];
                break;
            default:
                break;
        }

        clearErrors();

        if (!this.props.isLoading) {
            this.props.toggleLoading(true);
            isCreated = await createSubscription(body);
        }

        if (isCreated) this.handleClose();
        this.props.toggleLoading(false);
    }

    handleClose = () => {
        this.props.clearErrors();
        this.props.toggleLoading(false);
        this.props.close();
    }

    render() {
        const {
            clientContacts,
            contacts,
            errors,
            open,
            selectedSubscription,
            title
        } = this.props;

        const {
            checkState,
            clientId,
            disableContact,
            formIsValid
        } = this.state;

        const fullFormIsValid = !!checkState.length && formIsValid;
        const isCompany = !!clientId;

        return (
            <EsmsDialog
                errors={errors}
                open={open}
                onClose={this.handleClose}
                title={title}
                onRendered={this.setInternalModel}
                onConfirm={this.handleCreate}
                disabled={!fullFormIsValid}
                isLoading={this.props.isLoading}
                confirmText="Subscribe"
            >
                <div className={classes.formColumn}>
                    <div className={classes.labelColumn}>
                        <div className={classes.labelHeader}>
                            <img src="/assets/images/RingingAlarmFlat.svg" alt="subscription icon" />
                            <span>Subscription</span>
                        </div>
                        <div className={classes.labelContent}>
                            <p>
                                Subscribing allows you to receive alerts for this entity as well as any children.
                            </p>
                        </div>
                    </div>
                    <div className={classes.inputColumn}>
                        <div className={classes.inputs}>
                            <h3 className={classes.subsectionTitle}>{this.prepareTitle(selectedSubscription.label)}</h3>
                            <span className={classes.subsectionSubTitle}>{this.prepareSubtitle(selectedSubscription.type)}</span>
                        </div>
                        <div className={classes.inputs}>
                            <FormControl className={classes.checkboxWrapper}>
                                <FormLabel
                                    component="legend"
                                    className={classes.checkboxGroupLabel}
                                >
                                    Subscription Method
                                </FormLabel>
                                <FormGroup row>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.formControls.email.value}
                                                value="email"
                                                name="email"
                                                color="primary"
                                                onChange={this.handleCheckbox('email')}
                                            />
                                        }
                                        label={this.state.formControls.email.placeholder}
                                        className={classes.checkboxLabel}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.formControls.sms.value}
                                                value="sms"
                                                name="sms"
                                                color="primary"
                                                onChange={this.handleCheckbox('sms')}
                                            />
                                        }
                                        label={this.state.formControls.sms.placeholder}
                                        className={classes.checkboxLabel}
                                    />
                                </FormGroup>
                            </FormControl>
                            <FormControl className={classes.checkboxWrapper}>
                                <FormLabel
                                    component="legend"
                                    className={classes.checkboxGroupLabel}
                                >
                                    Subscribe
                                </FormLabel>
                                <RadioGroup
                                    row
                                    name="subscribe"
                                    onChange={this.handleRadioButton}
                                    value={this.state.formControls.subscribe.value}
                                >
                                    <FormControlLabel
                                        value="self"
                                        control={<Radio color="primary" />}
                                        label="Self"
                                        className={classes.checkboxLabel}
                                        disabled={!isCompany}
                                    />
                                    <FormControlLabel
                                        value="clientContact"
                                        control={<Radio color="primary" />}
                                        label="Client Contact"
                                        className={classes.checkboxLabel}
                                        disabled={!isCompany}
                                        color="primary"
                                    />
                                    <FormControlLabel
                                        value="both"
                                        control={<Radio color="primary" />}
                                        label="Both"
                                        className={classes.checkboxLabel}
                                        disabled={!isCompany}
                                        color="primary"
                                    />
                                </RadioGroup>
                            </FormControl>
                            <FormControl className={classes.inputWrapper}>
                                <InputLabel
                                    htmlFor="contact"
                                    classes={{
                                        focused: classes.cssFocused
                                    }}
                                >
                                    {this.state.formControls.contact.placeholder}
                                </InputLabel>
                                <Select
                                    value={this.state.formControls.contact.value}
                                    onChange={this.handleChange}
                                    className={classes.select}
                                    disabled={disableContact}
                                    inputProps={{
                                        name: 'contact',
                                        id:   'contact'
                                    }}
                                >
                                    {
                                        process.env.contactsEnabled ?
                                            clientContacts.map(contact =>
                                                <MenuItem
                                                    key={contact.id}
                                                    value={contact.id}
                                                >
                                                    {contact.userName.FirstName} {contact.userName.LastName}
                                                </MenuItem>
                                            )
                                            :
                                            contacts.map(contact =>
                                                <MenuItem
                                                    key={contact.id}
                                                    value={contact.id}
                                                >
                                                    {contact.name}
                                                </MenuItem>
                                            )
                                    }
                                </Select>
                                {!this.state.formControls.contact.valid &&
                                  this.state.formControls.contact.touched && <FormHelperText className={classes.error}>{this.state.formControls.contact.message}</FormHelperText>}
                            </FormControl>
                        </div>
                    </div>
                </div>
            </EsmsDialog>
        );
    }
}

SubscriptionModal.defaultProps = {

};

SubscriptionModal.propTypes = {
    close: func.isRequired,
    open:  bool.isRequired,
    title: string.isRequired
};

const mapStateToProps = state => {
    const {
        contacts,
        order,
        orderBy: orderByKey
    } = state.architect;

    return {
        companyInfo:          state.companyInfo,
        clientContacts:       state.contact.clientContacts,
        contacts:             _.orderBy(contacts, [orderByKey], order),
        currentUserId:        state.currentUser.id,
        errors:               state.messages.errors,
        isLoading:            state.ui.isLoading,
        selectedSite:         state.site.selectedSite,
        selectedSubscription: state.home.selectedSubscription
    };
};

const mapDispatchToProps = {
    ...ApplicationMessageActions,
    ...ArchitectActions,
    ...ContactActions,
    ...HomeActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionModal);
